import { jsx as _jsx } from "react/jsx-runtime";
import { isFunction } from '@seiue/util';
import { Portal } from '../Portal';
import { Drawer } from './Drawer';
export const openDrawer = (props) => {
    const modalKey = Portal.add(_jsx(Drawer, Object.assign({ visible: true, onClose: e => {
            if (isFunction(props.onClose)) {
                props.onClose(e);
            }
            else {
                Portal.remove(modalKey);
            }
        } }, props), void 0));
    return {
        hide: () => Portal.remove(modalKey),
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3Blbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9EcmF3ZXIvb3Blbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBRSxVQUFVLEVBQUUsTUFBTSxhQUFhLENBQUE7QUFHeEMsT0FBTyxFQUFFLE1BQU0sRUFBRSxNQUFNLFdBQVcsQ0FBQTtBQUVsQyxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBRWpDLE1BQU0sQ0FBQyxNQUFNLFVBQVUsR0FBRyxDQUN4QixLQUVDLEVBQ0QsRUFBRTtJQUNGLE1BQU0sUUFBUSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQ3pCLEtBQUMsTUFBTSxrQkFDTCxPQUFPLEVBQUUsSUFBSSxFQUNiLE9BQU8sRUFBRSxDQUFDLENBQUMsRUFBRTtZQUNYLElBQUksVUFBVSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsRUFBRTtnQkFDN0IsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQTthQUNqQjtpQkFBTTtnQkFDTCxNQUFNLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFBO2FBQ3hCO1FBQ0gsQ0FBQyxJQUNHLEtBQUssVUFDVCxDQUNILENBQUE7SUFFRCxPQUFPO1FBQ0wsSUFBSSxFQUFFLEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDO0tBQ3BDLENBQUE7QUFDSCxDQUFDLENBQUEifQ==